import { LargeButton as CoreLargeButton } from "components/core";
import styled from "styled-components";
import { colors } from "theme";

export const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: ${({ vertical }) => (vertical ? "column" : "row")};
  row-gap: 14px;
  column-gap: 20px;
  flex-wrap: wrap;
  width:"900px"
`;

export const BenefitSetupWrapper = styled.section`
  display: flex;
  gap: 24px;
  & > :first-child {
    flex-basis: 20%;
    margin-top: 36px;
  }
  
  & > :last-child {
    flex-basis: 62%;
    margin-top: 36px;
  }
`;

export const BenefitDetailWrapper = styled.article`
  display: flex;
  flex-direction: column;
  gap: 44px;
  & > :first-child {
    background-color: rgba(240, 240, 240, 0.2);
    border-radius: 10px;
    padding: 34px 36px;
    border: 1px solid #BEAAD1;
  }
`;


export const ChooseTypeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem; /* horizontal + vertical gap between cards */
  justify-content: flex-start;
  align-items: center;
  margin-bottom:12px
`;

// Benefit form wrapper - column flex with spacing between sections and buttons
export const BenefitFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem; /* vertical spacing between child sections/buttons */
`;


export const DependentsCard = styled.div`
  flex: 1 1 140px; /* grow/shrink with min width */
  min-width: 140px;
  margin: 0;
  padding: 0.75rem 1rem;
  border: 1px solid ${({ selected }) => (selected ? "#007FFF" : "#ccc")};
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
  text-align: center;
  background-color: ${({ selected }) => (selected ? "#e6f2ff" : "transparent")};
  &:hover {
    border-color: #007FFF;
  }
`;


export const BenefitSetupDetailGrade = styled.div`
  margin-bottom: 1.5rem;
`;

export const BenefitSetupDetailSection = styled.section`
  margin-bottom: 1.5rem;
`;

export const BenefitSaveBtn = styled(CoreLargeButton)`
  background-color: #452D84;
  color: ${colors.whiteColor};
  border: 1px solid ${colors.primaryColor};
  margin-top: 1rem;
  display: flex;
  max-width: 150px;
  max-height: 48px;
`;
export const LargeButton = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  border-radius: 8px;
  margin-top: 1.5rem;
`;

// Wrapper for summary post content with styled header and section
export const BenefitSummaryPostWrapper = styled.section`
  background-color: white;
  border-radius: 10px;
  & > header {
    padding: 24px;
    background-color: #221B3C;
    border-radius: 10px 10px 0 0;
  }
  & > section {
    padding: 24px;
  }
`;

export const BenefitDetailBlockWrapper = styled.section`
  display: grid;
  width: 800px;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
`;
